import { combineReducers } from 'redux';

const questions = (state = { totalCount: 0, result: [] }, action) => {
  switch (action.type) {
    case 'FETCH_PRESCREEN_QUESTIONS_FULFILLED':
      return action.payload.data;
    case 'FETCH_PRESCREEN_QUESTIONS_REJECTED':
      return { totalCount: 0, result: [] };
    default:
      return state;
  }
};

const activeQuestions = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ACTIVE_PRESCREEN_QUESTIONS_FULFILLED':
      return action.payload.data.result;
    case 'FETCH_ACTIVE_PRESCREEN_QUESTIONS_REJECTED':
      return [];
    default:
      return state;
  }
};

const archivedQuestions = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ARCHIVED_PRESCREEN_QUESTIONS_FULFILLED':
      return action.payload.data.result;
    case 'FETCH_ARCHIVED_PRESCREEN_QUESTIONS_REJECTED':
      return [];
    default:
      return state;
  }
};

const instance = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_PRESCREEN_QUESTIONS_INSTANCE_FULFILLED':
      return action.payload.data;
    case 'FETCH_PRESCREEN_QUESTIONS_INSTANCE_REJECTED':
      return [];
    default:
      return state;
  }
};

const questionsLoaded = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_PRESCREEN_QUESTIONS_PENDING':
      return false;
    case 'FETCH_PRESCREEN_QUESTIONS_REJECTED':
    case 'FETCH_PRESCREEN_QUESTIONS_FULFILLED':
      return true;
    default:
      return state;
  }
};

const activeLoaded = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_ACTIVE_PRESCREEN_QUESTIONS_PENDING':
      return false;
    case 'FETCH_ACTIVE_PRESCREEN_QUESTIONS_FULFILLED':
    case 'FETCH_ACTIVE_PRESCREEN_QUESTIONS_REJECTED':
      return true;
    default:
      return state;
  }
};

const archivedLoaded = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_ARCHIVED_PRESCREEN_QUESTIONS_PENDING':
      return false;
    case 'FETCH_ARCHIVED_PRESCREEN_QUESTIONS_FULFILLED':
    case 'FETCH_ARCHIVED_PRESCREEN_QUESTIONS_REJECTED':
      return true;
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_PRESCREEN_QUESTIONS_PENDING':
      return true;
    case 'FETCH_PRESCREEN_QUESTIONS_REJECTED':
    case 'FETCH_PRESCREEN_QUESTIONS_FULFILLED':
      return false;
    default:
      return state;
  }
};

const errorMessage = (state = null, action) => {
  switch (action.type) {
    case 'FETCH_PRESCREEN_QUESTIONS_PENDING':
    case 'FETCH_PRESCREEN_QUESTIONS_FULFILLED':
      return null;
    case 'FETCH_PRESCREEN_QUESTIONS_REJECTED':
      return action.payload.message;
    default:
      return state;
  }
};

const instanceIsFetching = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_PRESCREEN_QUESTIONS_INSTANCE_PENDING':
      return true;
    case 'FETCH_PRESCREEN_QUESTIONS_INSTANCE_FULFILLED':
    case 'FETCH_PRESCREEN_QUESTIONS_INSTANCE_REJECTED':
      return false;
    default:
      return state;
  }
};
const instanceErrorMessage = (state = null, action) => {
  switch (action.type) {
    case 'FETCH_PRESCREEN_QUESTIONS_INSTANCE_PENDING':
    case 'FETCH_PRESCREEN_QUESTIONS_INSTANCE_FULFILLED':
      return null;
    case 'FETCH_PRESCREEN_QUESTIONS_INSTANCE_REJECTED':
      return action.payload.message;
    default:
      return state;
  }
};

const prescreen = combineReducers({
  questions,
  activeQuestions,
  archivedQuestions,
  instance,
  isFetching,
  errorMessage,
  instanceIsFetching,
  instanceErrorMessage,
  questionsLoaded,
  activeLoaded,
  archivedLoaded,
});

export default prescreen;
